import { useEffect } from 'react';
import NProgress from 'nprogress';
import { LinearProgress } from 'src/componentes/LinearProgress';

const LoadingScreen = ({ containerDiffHeight }) => {
  useEffect(() => {
    NProgress.configure({ showSpinner: false });
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div
      className="loading-screen loading-screen--default"
      style={{
        height: containerDiffHeight
          ? `calc(100vh - ${containerDiffHeight}px)`
          : '100%',
      }}
    >
      <div style={{ width: 400 }}>
        <LinearProgress />
      </div>
    </div>
  );
};

export default LoadingScreen;
